import Button from "../CustomButtons/Button"
import { makeStyles } from "@material-ui/core/styles"
import CloudUploadIcon from "@material-ui/icons/CloudUpload"
import React, { useState } from "react"
import { ValidatorForm } from "react-material-ui-form-validator"
import { useDispatch, useSelector } from "react-redux"
import { Loader } from "../../components"
import * as actionUsers from "../../store/actions/userActions"
import { getFileObject, getUser } from "../../utils"
import ContainerStyle from "../GridContainer/GridContainer"

const useStylesCont = makeStyles(theme => ContainerStyle)
const UploadAvator = () => {
  const { isLoading, error, message } = useSelector(state => ({
    isLoading: state.user.loading,
    error: state.user.error,
    message: state.user.message,
  }))

  const dispatch = useDispatch()
  const uid_uuid = getUser("id")
  const [filesData, setFilesData] = useState()

  const handleSubmit = event => {
    event.preventDefault()
    dispatch(actionUsers.userAvatorUpdate(filesData, uid_uuid))
  }

  const selectFiles = event => {
    event.preventDefault()
    let AvatorFile = event.target.files[0]
    let Avator = getFileObject(AvatorFile, "image")

    Avator.then(function(fileData) {
      setFilesData(fileData)
    }).catch(function(error) {
      console.log("error:", error)
    })
  }

  const classes = useStylesCont()
  return (
    <div>
      <ValidatorForm
        onSubmit={event => {
          handleSubmit(event)
        }}
        onError={errors => console.log(errors)}
      >
        <Loader isStart={isLoading} />
        <input name="profileImage" type="file" onChange={e => selectFiles(e)} />
        <Button
          color="blue"
          type="submit"
          variant="contained"
          className={classes.button}
        >
          Upload &nbsp;
          <CloudUploadIcon className={classes.rightIcon} />
        </Button>
      </ValidatorForm>
    </div>
  )
}

export default UploadAvator
